// 交易详情相关类型定义

// 交易类型枚举
export enum TransactionType {
    DEPOSIT = 'Deposit', // 充值
    WITHDRAW = 'Withdraw', // 提现
}

// 主状态枚举 - 对应API返回的真实业务状态
export enum TransactionStatus {
    SUCCESS = 'Success', // 成功/已完成
    PROCESSING = 'Processing', // 进行中
    FAILED = 'Failed', // 失败
    WITHDRAWN = 'Withdrawn', // 提现已撤回
}

// 详细状态枚举 - 用于前端UI展示和交互逻辑
export enum TransactionDetailStatus {
    // 充值详细状态
    DEPOSIT_PROCESSING = 'DepositProcessing', // 充值进行中（正常进行中的订单）
    DEPOSIT_ORDER_CLOSED = 'DepositOrderClosed', // 充值订单关闭（仍属于Processing，但UI略有不同）
    DEPOSIT_SUCCESS = 'DepositSuccess', // 充值成功

    // 提现详细状态
    WITHDRAW_BACKEND_REVIEWING = 'WithdrawBackendReviewing', // 后台审核中（可撤回）
    WITHDRAW_BACKEND_REVIEWED = 'WithdrawBackendReviewed', // 后台审核完成（不可撤回）
    WITHDRAW_SUCCESS = 'WithdrawSuccess', // 提现成功
    WITHDRAW_WITHDRAWN = 'WithdrawWithdrawn', // 提现已撤回（Failed状态的一种）
    WITHDRAW_REJECTED = 'WithdrawRejected', // 提现未通过（Failed状态的一种）
}

// 步骤状态枚举
export enum StepStatus {
    COMPLETED = 'completed',
    PROCESSING = 'processing',
    PENDING = 'pending',
    FAILED = 'failed',
}

// 交易记录列表数据
export interface TransactionList {
    id: string
    time: string
    type: TransactionType
    amount: number
    curSymbol: string
    currency: string
    status: TransactionStatus // 主状态（Success/Processing/Failed）
}

// 提现消息信息接口
export interface WithdrawMessageInfo {
    title: string
    content: string
}

// 交易详情接口
export interface TransactionDetail {
    id: string // 交易ID
    time: string // 交易时间
    type: TransactionType // 交易类型（充值/提现）
    amount: number // 交易金额
    curSymbol: string // 货币符号
    currency: string // 货币类型
    status: TransactionStatus // 主状态（Success/Processing/Failed）
    detailStatus: TransactionDetailStatus // 详细状态（用于UI展示逻辑）
    fee?: number // 手续费
    description?: string // 交易描述
    paymentChannel?: string // 支付渠道
    countdownTime?: number // 倒计时时间（秒）
    failReason?: string // 失败原因
    countdownFinished?: boolean // 倒计时是否完成
    payurl?: string // 三方的支付链接
    before?: number // 交易前余额
    after?: number // 交易后余额
    finishat?: string // 完成时间
    gold?: number // 奖励金币
    at?: string // 加速时间
    withdrawnTime?: string // 提现已撤回时间
    platcreateat?: string // 平台创建时间 提现使用
}

// 按钮配置接口
// 交易操作类型枚举
export enum TransactionAction {
    NONE = 'none', // 无操作
    SPEED_UP = 'speedUp', // 加速操作
    CANCEL = 'Withdraw', // 撤回操作
}

export interface ButtonConfig {
    text: string // 按钮文本
    disabled: boolean // 是否禁用
    action: TransactionAction // 按钮动作类型
    showCountdown?: boolean // 是否显示倒计时
}

// 交易状态接口 - 用于组件间状态传递
// export interface TransactionState {
//     type: TransactionType // 交易类型
//     status: TransactionStatus // 主状态
//     detailStatus: TransactionDetailStatus // 详细状态
//     canWithdraw?: boolean // 是否可以撤回
//     countdownTime?: number // 倒计时时间
//     failReason?: string // 失败原因
// }
